import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import SvgReceiptAttached from 'src/components/Svgs/SvgReceiptAttached'
import SvgReceiptMissing from 'src/components/Svgs/SvgReceiptMissing'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ReceiptsTooltipProps {
  count?: number
  openLeft: boolean
  isMissing?: boolean
}

const ReceiptsTooltip: React.FC<ReceiptsTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <TooltipIcon
      placement={props.openLeft ? 'left' : 'right'}
      icon={
        props.isMissing ? (
          <SvgReceiptMissing
            css={css`
              transform: scale(calc(20 / 24));
            `}
          />
        ) : (
          <SvgReceiptAttached
            css={css`
              transform: scale(calc(20 / 24));
            `}
          />
        )
      }
      iconTestId={
        props.isMissing ? 'missingReceiptsIcon' : 'receiptsAttachedIcon'
      }
    >
      {props.count !== undefined && (
        <p>
          {props.count === 1 && (
            <Trns
              source={'${count} receipt'}
              expressions={{
                count: `${props.count}`,
              }}
            />
          )}
          {props.count !== 1 && (
            <Trns
              source={'${count} receipts'}
              expressions={{
                count: `${props.count}`,
              }}
            />
          )}
        </p>
      )}
      {props.isMissing && (
        <p>
          <Trns source={'Receipt required'} />
        </p>
      )}
    </TooltipIcon>
  )
}

export default ReceiptsTooltip
